import Head from 'next/head'

export default function CmsHeadComponent ({ fields }) {
  return (
    <Head>
      <title>
        {fields.SEO?.MetaTitle || fields.title}
      </title>
      <meta
        name="description"
        content={fields.SEO?.MetaDescription || ''}
      />
      {
        fields.SEO?.MetaTag.map((tag, index) => (
          <meta
            key={index}
            name={tag.name}
            content={tag.content}
          />
        ))
      }
    </Head>
  )
}
